/**
 * Helper to calculate column width
 */
export const getColumnWidth = (width: number, sortable: boolean, widthUnit: number): number => {
	const SORT_ICON_WIDTH = 20

	// If width unit is PIXEL (2), add sort icon width
	if (widthUnit === 2) {
		return sortable ? width + SORT_ICON_WIDTH : width
	}

	// If width unit is PERCENT (1), return as is (will be converted to flex)
	return width
}

/**
 * Helper to get system column width
 */
export const getSystemColumnWidth = (translation: string, widthUnit: number): number => {
	if (widthUnit === 2) {
		// PIXEL mode (2)
		const widths: Record<string, number> = {
			note: 200,
			annotated: 200,
			checked: 200,
			ta_categories: 500,
			ta_sentiment: 200,
		}
		return widths[translation] || 200
	}

	// PERCENT mode (1)
	const widths: Record<string, number> = {
		note: 10,
		annotated: 8,
		checked: 8,
		ta_categories: 25,
		ta_sentiment: 8,
	}
	return widths[translation] || 8
}
